module.exports = __webpack_public_path__ + "resources/img/img_experdb_m.68bc41be9d3e6d5b19e4b2e62aad4d51.png";